import type { EntityData } from '@adornis/baseql/entities/types.js';
import type { RegistrationUserDataPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import type { BHTranslationDictionary } from '@adornis/buchungsheld-db/translations/translation.js';
import type { GenericFieldFormController } from '@adornis/cms/client/generic-field-formcontroller.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { html, nothing } from 'lit';
import {
  MzsDesiredDegreeEnum,
  MZSInstitutionEnum,
  MzsOfferEnum,
  type MzsStammdaten,
} from '../stammdaten/mzs-stammdaten-plugin.js';

type stammdatenKeys = keyof EntityData<MzsStammdaten>;

export const mzsRegistrationUserDataPlugin: RegistrationUserDataPlugin<MzsStammdaten> = {
  id: 'registration::user-data::mzs',
  type: 'registration::user-data',
  render: (
    stammdatenController: GenericFieldFormController<MzsStammdaten>,
    translationController: TranslationController<BHTranslationDictionary>,
  ) => {
    const genericFieldOption = (fieldName: string) =>
      ({
        placeholder: translationController.translate('mzs', 'field', fieldName as any) as string,
        placeholderMode: 'static-floating',
      } as const);

    return html`
      <x-flex space="lg">
        <x-flex space="sm">
          ${(['salutation', 'currentUni', 'institution'] as stammdatenKeys[]).map(fieldName =>
            stammdatenController.genericField([fieldName], genericFieldOption(fieldName)),
          )}
          ${stammdatenController.document?.institution === MZSInstitutionEnum.MZSOTHERS
            ? stammdatenController.genericField(['institutionOther'], genericFieldOption('institutionOther'))
            : nothing}
          ${(['desiredDegree'] as stammdatenKeys[]).map(fieldName =>
            stammdatenController.genericField([fieldName], genericFieldOption(fieldName)),
          )}
          ${stammdatenController.document?.desiredDegree === MzsDesiredDegreeEnum.MZS_SONSTIGE
            ? stammdatenController.genericField(['desiredDegreeOther'], genericFieldOption('desiredDegreeOther'))
            : nothing}
          ${(['statusGroup'] as stammdatenKeys[]).map(fieldName =>
            stammdatenController.genericField([fieldName], genericFieldOption(fieldName)),
          )}
          ${
            /*stammdatenController.document?.statusGroup === MzsStatusGroupEnum.MZSSONSTIGE
            ? stammdatenController.genericField(['statusGroupOther'], genericFieldOption('statusGroupOther'))
            : nothing*/ nothing
          }
          ${(['hearAboutOffer'] as stammdatenKeys[]).map(fieldName =>
            stammdatenController.genericField([fieldName], genericFieldOption(fieldName)),
          )}
          ${stammdatenController.document?.hearAboutOffer === MzsOfferEnum.MZS_OTHER_OPTION
            ? stammdatenController.genericField(['hearAboutOfferOther'], genericFieldOption('hearAboutOfferOther'))
            : nothing}
          <x-flex space="xs">
            <x-text tone="subtle"> ${translationController.translate('mzs', 'field', 'participatedBefore')} </x-text>
            <x-radiogroup ${stammdatenController.field('participatedBefore')}>
              <x-flex horizontal space="md">
                <x-radiobutton .selectable=${true}>
                  ${translationController.translate('mzs', 'field', 'participatedBeforeYes')}
                </x-radiobutton>
                <x-radiobutton .selectable=${false}>
                  ${translationController.translate('mzs', 'field', 'participatedBeforeNo')}
                </x-radiobutton>
              </x-flex>
            </x-radiogroup>
          </x-flex>
        </x-flex>
      </x-flex>
    `;
  },
};
